<template>
  <div id="botpress-webchat"></div>
</template>

<script>
export default {
  data() {
    return {
      municipio: null,
    };
  },

  async mounted() {
    await this.buscarMunicipio();

    // Carrega a biblioteca principal do Botpress
    await this.carregarScript(
      "https://cdn.botpress.cloud/webchat/v3.5/inject.js"
    );

    // Registra o evento antes de inicializar o Botpress
    window.botpress.on("webchat:ready", () => {
      const customEvent = {
        type: "customEvent",
        channel: "web",
        payload: {
          text: "municipio_inicial",
        },
        extraProps: {
          municipio: this.municipio,
          cod_user: this.$store.state.user.id,
          nome_user: this.$store.state.user.name,
          email_user: this.$store.state.user.email,
          unidade_id: this.$store.state.user.tecnico.unidade_id,
          unidade_nome: this.$store.state.user.tecnico.unidade.nome,
        },
      };

      window.botpress.sendEvent(customEvent);
    });

    // Este arquivo inicializa o Botpress
    await this.carregarScript(
      "https://files.bpcontent.cloud/2025/07/24/18/20250724185805-5QD7JGXY.js"
    );

    // O botão só é procurado depois da inicialização
    this.ativarArrasteBotpress();
  },

  beforeDestroy() {
    if (this._intervaloBotpress) {
      window.clearInterval(this._intervaloBotpress);
      this._intervaloBotpress = null;
    }

    if (this._limparArrasteBotpress) {
      this._limparArrasteBotpress();
      this._limparArrasteBotpress = null;
    }
  },

  methods: {
    carregarScript(src) {
      return new Promise((resolve, reject) => {
        const scriptExistente = document.querySelector(
          `script[src="${src}"]`
        );

        if (scriptExistente) {
          return resolve();
        }

        const script = document.createElement("script");

        script.src = src;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;

        document.body.appendChild(script);
      });
    },

    async buscarMunicipio() {
      this.municipio = this.$store.state.municipio;

      if (!this.municipio) {
        const params = new URLSearchParams(window.location.search);

        this.municipio =
          params.get("municipio") || "não identificado";
      }

      console.log("🏙️ Município:", this.municipio);
    },

    ativarArrasteBotpress() {
      const localizarBotao = () => {
        /*
         * No Botpress 3.5, o botão fica dentro do Shadow DOM
         * do elemento #fab-root.
         */
        const host = document.getElementById("fab-root");

        if (!host || !host.shadowRoot) {
          return false;
        }

        const botao = host.shadowRoot.querySelector(
          ".bpFabWrapper"
        );

        if (!botao) {
          return false;
        }

        // O mesmo botão já está configurado
        if (this._botaoBotpressAtual === botao) {
          return true;
        }

        // Limpa os listeners de um botão anterior, se houver
        if (this._limparArrasteBotpress) {
          this._limparArrasteBotpress();
          this._limparArrasteBotpress = null;
        }

        this._botaoBotpressAtual = botao;
        botao.dataset.arrastavel = "1";

        /*
         * O CSS da página não atravessa o Shadow DOM.
         * Por isso os estilos necessários são aplicados diretamente.
         */
        botao.style.setProperty(
          "touch-action",
          "none",
          "important"
        );

        botao.style.setProperty(
          "user-select",
          "none",
          "important"
        );

        botao.style.setProperty(
          "-webkit-user-select",
          "none",
          "important"
        );

        botao.style.cursor = "grab";

        // Impede que a imagem seja arrastada pelo navegador
        const imagem = botao.querySelector("img");

        if (imagem) {
          imagem.draggable = false;

          imagem.style.setProperty(
            "pointer-events",
            "none",
            "important"
          );
        }

        this.configurarArrasteBotpress(botao);

        return true;
      };

      // Tenta localizar imediatamente
      localizarBotao();

      /*
       * MutationObserver no body não observa o interior
       * do Shadow DOM. O intervalo também cobre eventuais
       * recriações do botão pelo Botpress.
       */
      this._intervaloBotpress = window.setInterval(() => {
        localizarBotao();
      }, 500);
    },

    configurarArrasteBotpress(botao) {
      const margem = 8;

      const usuarioId = this.$store.state.user.id;

      const chavePosicao =
        `botpress-posicao-${usuarioId}`;

      let arrastando = false;
      let movimentou = false;
      let bloquearClique = false;
      let posicaoPersonalizada = false;
      let ponteiroAtivo = null;
      let timerBloqueioClique = null;

      let inicioMouseX = 0;
      let inicioMouseY = 0;
      let inicioBotaoX = 0;
      let inicioBotaoY = 0;

      const aplicarPosicao = (x, y) => {
        const larguraBotao = botao.offsetWidth || 64;
        const alturaBotao = botao.offsetHeight || 64;

        const limiteX = Math.max(
          margem,
          window.innerWidth - larguraBotao - margem
        );

        const limiteY = Math.max(
          margem,
          window.innerHeight - alturaBotao - margem
        );

        const novaPosicaoX = Math.min(
          Math.max(x, margem),
          limiteX
        );

        const novaPosicaoY = Math.min(
          Math.max(y, margem),
          limiteY
        );

        /*
         * "important" garante que a posição vença os estilos
         * internos do Botpress.
         */
        botao.style.setProperty(
          "position",
          "fixed",
          "important"
        );

        botao.style.setProperty(
          "left",
          `${novaPosicaoX}px`,
          "important"
        );

        botao.style.setProperty(
          "top",
          `${novaPosicaoY}px`,
          "important"
        );

        botao.style.setProperty(
          "right",
          "auto",
          "important"
        );

        botao.style.setProperty(
          "bottom",
          "auto",
          "important"
        );
      };

      const salvarPosicao = () => {
        const posicaoFinal =
          botao.getBoundingClientRect();

        try {
          localStorage.setItem(
            chavePosicao,
            JSON.stringify({
              x: posicaoFinal.left,
              y: posicaoFinal.top,
            })
          );
        } catch (error) {
          console.warn(
            "Não foi possível salvar a posição do Botpress.",
            error
          );
        }
      };

      // Recupera a última posição escolhida pelo usuário
      try {
        const posicaoSalva = JSON.parse(
          localStorage.getItem(chavePosicao)
        );

        if (
          posicaoSalva &&
          Number.isFinite(posicaoSalva.x) &&
          Number.isFinite(posicaoSalva.y)
        ) {
          posicaoPersonalizada = true;

          window.requestAnimationFrame(() => {
            aplicarPosicao(
              posicaoSalva.x,
              posicaoSalva.y
            );
          });
        }
      } catch (error) {
        console.warn(
          "Não foi possível recuperar a posição do Botpress.",
          error
        );
      }

      const iniciarArraste = (event) => {

        if (
          event.pointerType === "mouse" &&
          event.button !== 0
        ) {
          return;
        }

        if (arrastando) {
          return;
        }

        const posicaoAtual =
          botao.getBoundingClientRect();

        arrastando = true;
        movimentou = false;
        ponteiroAtivo = event.pointerId;

        inicioMouseX = event.clientX;
        inicioMouseY = event.clientY;
        inicioBotaoX = posicaoAtual.left;
        inicioBotaoY = posicaoAtual.top;

        botao.style.cursor = "grabbing";

      };

      const movimentarBotao = (event) => {
        if (!arrastando) {
          return;
        }

        if (
          ponteiroAtivo !== null &&
          event.pointerId !== ponteiroAtivo
        ) {
          return;
        }

        const movimentoX =
          event.clientX - inicioMouseX;

        const movimentoY =
          event.clientY - inicioMouseY;

        /*
         * Evita considerar um toque ou clique normal
         * como arraste.
         */
        if (
          !movimentou &&
          Math.abs(movimentoX) < 5 &&
          Math.abs(movimentoY) < 5
        ) {
          return;
        }

        movimentou = true;
        posicaoPersonalizada = true;

        event.preventDefault();

        aplicarPosicao(
          inicioBotaoX + movimentoX,
          inicioBotaoY + movimentoY
        );
      };

      const finalizarArraste = (event) => {
        if (!arrastando) {
          return;
        }

        if (
          event &&
          ponteiroAtivo !== null &&
          event.pointerId !== ponteiroAtivo
        ) {
          return;
        }

        arrastando = false;
        ponteiroAtivo = null;
        botao.style.cursor = "grab";

        // Se não movimentou, deixa o clique normal abrir o chat
        if (!movimentou) {
          return;
        }

        salvarPosicao();

        // Bloqueia somente o clique gerado depois de um arraste
        bloquearClique = true;

        if (timerBloqueioClique) {
          window.clearTimeout(timerBloqueioClique);
        }

        timerBloqueioClique = window.setTimeout(() => {
          bloquearClique = false;
          timerBloqueioClique = null;
        }, 150);
      };

      const controlarClique = (event) => {
        if (!bloquearClique) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        bloquearClique = false;

        if (timerBloqueioClique) {
          window.clearTimeout(timerBloqueioClique);
          timerBloqueioClique = null;
        }
      };

      const impedirArrasteNativo = (event) => {
        event.preventDefault();
      };

      const ajustarAoRedimensionar = () => {
        if (!posicaoPersonalizada) {
          return;
        }

        const posicaoAtual =
          botao.getBoundingClientRect();

        aplicarPosicao(
          posicaoAtual.left,
          posicaoAtual.top
        );

        salvarPosicao();
      };

      botao.addEventListener(
        "pointerdown",
        iniciarArraste
      );

      botao.addEventListener(
        "dragstart",
        impedirArrasteNativo
      );

      botao.addEventListener(
        "click",
        controlarClique,
        true
      );

      window.addEventListener(
        "pointermove",
        movimentarBotao,
        { passive: false }
      );

      window.addEventListener(
        "pointerup",
        finalizarArraste
      );

      window.addEventListener(
        "pointercancel",
        finalizarArraste
      );

      window.addEventListener(
        "resize",
        ajustarAoRedimensionar
      );

      this._limparArrasteBotpress = () => {
        if (timerBloqueioClique) {
          window.clearTimeout(timerBloqueioClique);
          timerBloqueioClique = null;
        }

        botao.removeEventListener(
          "pointerdown",
          iniciarArraste
        );

        botao.removeEventListener(
          "dragstart",
          impedirArrasteNativo
        );

        botao.removeEventListener(
          "click",
          controlarClique,
          true
        );

        window.removeEventListener(
          "pointermove",
          movimentarBotao
        );

        window.removeEventListener(
          "pointerup",
          finalizarArraste
        );

        window.removeEventListener(
          "pointercancel",
          finalizarArraste
        );

        window.removeEventListener(
          "resize",
          ajustarAoRedimensionar
        );

        botao.style.removeProperty("touch-action");
        botao.style.removeProperty("user-select");
        botao.style.removeProperty("-webkit-user-select");
        botao.style.removeProperty("cursor");

        delete botao.dataset.arrastavel;

        if (this._botaoBotpressAtual === botao) {
          this._botaoBotpressAtual = null;
        }
      };
    },
  },
};
</script>